// project imports
import config from 'config';

// action - state management
import * as actionTypes from './actions';
import Cookies from 'universal-cookie';
export const initialState = {
    cart: [], //JSON.parse(localStorage.getItem('cart')) // for active default menu
    customer: {},
    paymentType: '',
    billing: {},
    wallet: {},
    reference: {},
    images: []
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const CartCustomerReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.Add_CartCustomer:
            return {
                ...state,
                cart: action.cart
            };
        case actionTypes.Add_CustomerCustomer:
            return {
                ...state,
                customer: action.customer
            };
        case actionTypes.Add_PaymentTypeCustomer:
            return {
                ...state,
                paymentType: action.paymentType
            };
        case actionTypes.Add_BillingCustomer:
            return {
                ...state,
                billing: action.billing
            };
        case actionTypes.Add_WalletCustomer:
            return {
                ...state,
                wallet: action.wallet
            };
        case actionTypes.Add_ReferenceCustomer:
            return {
                ...state,
                reference: action.reference
            };
        case actionTypes.Add_ImagesCustomer:
            return {
                ...state,
                images: action.images
            };
        default:
            return state;
    }
};

export default CartCustomerReducer;
